export const marketingAutomationHandler = {
    pathPattern: '/brands/:brandId/marketing/automations/:campaignId',
    toWeb: ({ brandId, campaignId }) => ({
        path: `/brands/${brandId}/marketing/automations/${campaignId}`,
    }),
    meta: {
        title: 'Marketing automation',
        description: 'Opens a marketing automation / campaign in the dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'campaignId', in: 'path', required: true },
        ],
        example: {
            params: {
                brandId: 'BXqExampleBrandId',
                campaignId: 'exampleCampaignId',
            },
        },
    },
};
//# sourceMappingURL=marketing-automation.js.map